import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyRegistry } from './currency-registry';
import { DecimalPipe } from './decimal.pipe';

@Pipe({
	name: 'currency'
})
export class CurrencyPipe implements PipeTransform {

	static transform(value: any, currency: string, thousandSeparator: boolean = true): any {
		const meta = CurrencyRegistry.get(currency);
		const p = meta.full_precision;
		const number = DecimalPipe.transform(value, p, p, thousandSeparator);
		return CurrencyRegistry.applyAffix(meta, number);
	}

	transform(value: any, currency: string, thousandSeparator: boolean = true): any {
		return CurrencyPipe.transform(value, currency, thousandSeparator);
	}

}
